import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

class AppBoundary extends React.Component<React.PropsWithChildren, {failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  render(){if(this.state.failed)return <main className="page"><div className="empty-state"><h1>Let’s pick that up again.</h1><p>Something interrupted this page. Reload to reconnect with your saved plans.</p><button className="btn gold" onClick={()=>location.reload()}>Reload</button></div></main>;return this.props.children;}
}
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><AppBoundary><App/></AppBoundary></React.StrictMode>);
